import defer from 'lib/deferred-promise';

export default function DeferAction(action) {
  return { ...action, deferred: defer() };
}
